// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"492e6b75","469":"0c9e7a00","977":"1fa8c7fd"}[chunkId] + ".chunk.js";
};